import { useTranslationContext } from "context/translation";
import { FC } from "react";
import { Image, ResponsiveImageType } from "react-datocms";
import { MachineRegistrationQuery } from "services/datocms/generated";
import st from "./MachineBanner.module.scss";
import cx from "classnames";

type MachineBannerProps = {
  machine: NonNullable<
    MachineRegistrationQuery["machineRegistrationPage"]
  >["machines"][number];
  backgroundImage?: ResponsiveImageType | null;
};

export const MachineBanner: FC<MachineBannerProps> = ({
  machine,
  backgroundImage,
}) => {
  const {
    youAreRegisteringYour = "You are registering your",
    sparklingWaterMaker = "Sparkling Water Maker",
  } = useTranslationContext();

  return (
    <div className="bg-white rounded-[20px] border border-gray-200 flex">
      <div className="basis-6/12 p-10 flex items-center">
        <h2 className="text-[18px] md:text-[32px] font-semibold">
          {youAreRegisteringYour}{" "}
          <span className="text-secondary">{machine.name}</span>{" "}
          {sparklingWaterMaker}
        </h2>
      </div>
      <div className="basis-6/12 relative flex justify-center overflow-hidden">
        {backgroundImage && (
          <>
            <div
              className={`${cx(
                st.imageAnimate,
                st.imageAnimateFront,
              )} absolute bottom-[-30%]`}
            >
              <Image data={backgroundImage} />
            </div>
            <div
              className={`${cx(
                st.imageAnimate,
                st.imageAnimateBack,
              )} absolute bottom-[-30%]`}
            >
              <Image data={backgroundImage} />
            </div>
          </>
        )}
        {machine.image?.responsiveImage && (
          <div className="relative bottom-[-20%]">
            <Image data={machine.image?.responsiveImage} />
          </div>
        )}
      </div>
    </div>
  );
};
